import { useState, useEffect, useRef } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCitiesOpen, setIsCitiesOpen] = useState(false);
  const [isVillesMenuOpen, setIsVillesMenuOpen] = useState(false);
  const citiesTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Close mobile menu when clicking outside
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  const navLinks = [
    { name: 'Accueil', href: '/' },
    { name: 'Services', href: '/#services' },
    { name: 'À Propos', href: '/#about' },
    { name: 'Contact', href: '/#contact' },
  ];

  const villes = [
    { name: 'Villeurbanne', href: '/reparation-fenetre-villeurbanne' },
    { name: 'Vénissieux', href: '/reparation-fenetre-venissieux' },
    { name: 'Caluire-et-Cuire', href: '/reparation-fenetre-caluire-et-cuire' },
    { name: 'Saint-Priest', href: '/reparation-fenetre-saint-priest' },
    { name: 'Vaulx-en-Velin', href: '/reparation-fenetre-vaulx-en-velin' },
    { name: 'Bron', href: '/reparation-fenetre-bron' },
    { name: 'Meyzieu', href: '/reparation-fenetre-meyzieu' },
    { name: 'Rillieux-la-Pape', href: '/reparation-fenetre-rillieux-la-pape' },
    { name: 'Décines-Charpieu', href: '/reparation-fenetre-decines-charpieu' },
    { name: 'Oullins', href: '/reparation-fenetre-oullins' },
    { name: 'Sainte-Foy-lès-Lyon', href: '/reparation-fenetre-sainte-foy-les-lyon' },
    { name: 'Tassin-la-Demi-Lune', href: '/reparation-fenetre-tassin-la-demi-lune' },
    { name: 'Écully', href: '/reparation-fenetre-ecully' },
    { name: 'Givors', href: '/reparation-fenetre-givors' },
    { name: 'Francheville', href: '/reparation-fenetre-francheville' },
    { name: 'Corbas', href: '/reparation-fenetre-corbas' },
    { name: 'Genas', href: '/reparation-fenetre-genas' },
    { name: 'Mions', href: '/reparation-fenetre-mions' },
    { name: 'Brignais', href: '/reparation-fenetre-brignais' },
    { name: 'Grigny', href: '/reparation-fenetre-grigny' },
    { name: 'Saint-Genis-Laval', href: '/reparation-fenetre-saint-genis-laval' },
    { name: 'Craponne', href: '/reparation-fenetre-craponne' },
    { name: 'Villefranche-sur-Saône', href: '/reparation-fenetre-villefranche-sur-saone' },
    { name: 'Mornant', href: '/reparation-fenetre-mornant' },
    { name: 'Anse', href: '/reparation-fenetre-anse' },
    { name: 'Couzon-au-Mont-d\'Or', href: '/reparation-fenetre-couzon-au-mont-d-or' },
    { name: 'Saint-Didier-au-Mont-d\'Or', href: '/reparation-fenetre-saint-didier-au-mont-d-or' },
    { name: 'Irigny', href: '/reparation-fenetre-irigny' },
    { name: 'Pierre-Bénite', href: '/reparation-fenetre-pierre-benite' },
    { name: 'Champagne-au-Mont-d\'Or', href: '/reparation-fenetre-champagne-au-mont-d-or' },
    { name: 'Saint-Fons', href: '/reparation-fenetre-saint-fons' },
    { name: 'Poleymieux-au-Mont-d\'Or', href: '/reparation-fenetre-poleymieux-au-mont-d-or' },
    { name: 'Limonest', href: '/reparation-fenetre-limonest' },
    { name: 'Solaize', href: '/reparation-fenetre-solaize' },
    { name: 'Curis-au-Mont-d\'Or', href: '/reparation-fenetre-curis-au-mont-d-or' },
    { name: 'Saint-Cyr-au-Mont-d\'Or', href: '/reparation-fenetre-saint-cyr-au-mont-d-or' },
    { name: 'Saint-Romain-au-Mont-d\'Or', href: '/reparation-fenetre-saint-romain-au-mont-d-or' },
    { name: 'Saint-Symphorien-sur-Coise', href: '/reparation-fenetre-saint-symphorien-sur-coise' },
    { name: 'Fontaines-sur-Saône', href: '/reparation-fenetre-fontaines-sur-saone' },
    { name: 'L\'Arbresle', href: '/reparation-fenetre-l-arbresle' },
    { name: 'Albigny-sur-Saône', href: '/reparation-fenetre-albigny-sur-saone' },
    { name: 'Feyzin', href: '/reparation-fenetre-feyzin' },
    { name: 'Chaponost', href: '/reparation-fenetre-chaponost' },
    { name: 'Vernaison', href: '/reparation-fenetre-vernaison' },
    { name: 'Belleville-en-Beaujolais', href: '/reparation-fenetre-belleville-en-beaujolais' },
    { name: 'Saint-Laurent-de-Mure', href: '/reparation-fenetre-saint-laurent-de-mure' },
    { name: 'Chassieu', href: '/reparation-fenetre-chassieu' },
    { name: 'Rochetaillée-sur-Saône', href: '/reparation-fenetre-rochetaillee-sur-saone' },
    { name: 'Charbonnières-les-Bains', href: '/reparation-fenetre-charbonnieres-les-bains' },
    { name: 'Neuville-sur-Saône', href: '/reparation-fenetre-neuville-sur-saone' },
    { name: 'Tarare', href: '/reparation-fenetre-tarare' },
    { name: 'Millery', href: '/reparation-fenetre-millery' },
    { name: 'Sathonay-Camp', href: '/reparation-fenetre-sathonay-camp' },
    { name: 'Sathonay-Village', href: '/reparation-fenetre-sathonay-village' },
    { name: 'Collonges-au-Mont-d\'Or', href: '/reparation-fenetre-collonges-au-mont-d-or' },
    { name: 'Dardilly', href: '/reparation-fenetre-dardilly' },
  ];

  const handleCitiesMouseEnter = () => {
    if (citiesTimeoutRef.current) {
      clearTimeout(citiesTimeoutRef.current);
    }
    setIsCitiesOpen(true);
  };

  const handleCitiesMouseLeave = () => {
    citiesTimeoutRef.current = setTimeout(() => {
      setIsCitiesOpen(false);
    }, 300);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          {/* Logo */}
          <a href="/" className="flex items-center gap-2 sm:gap-3 group cursor-pointer">
            <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-600 rounded-lg flex items-center justify-center group-hover:bg-teal-700 transition-colors">
              <i className="ri-window-line text-xl sm:text-2xl text-white"></i>
            </div>
            <div>
              <h1 className={`text-base sm:text-xl font-bold ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
                Fenêtres Lyon
              </h1>
              <p className={`text-xs ${isScrolled ? 'text-gray-600' : 'text-teal-100'} hidden sm:block`}>
                Réparation & Dépannage
              </p>
            </div>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className={`text-sm font-medium transition-colors hover:text-teal-500 cursor-pointer ${
                  isScrolled ? 'text-gray-700' : 'text-white'
                }`}
              >
                {link.name}
              </a>
            ))}
          </div>

          {/* Desktop CTA Buttons - Villes + Devis */}
          <div className="hidden lg:flex items-center gap-3">
            {/* Visio Diagnostic Button */}
            <a 
              href="/#whatsapp-diagnostic" 
              className="flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-teal-500 to-teal-600 text-white text-sm font-semibold rounded-lg hover:from-teal-600 hover:to-teal-700 transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-video-chat-line text-lg"></i>
              <span>Visio Diagnostic</span>
            </a>

            {/* Cities Dropdown */}
            <div 
              className="relative"
              onMouseEnter={handleCitiesMouseEnter}
              onMouseLeave={handleCitiesMouseLeave}
            >
              <button
                className={`flex items-center space-x-2 px-4 py-2 rounded-lg border-2 transition-all duration-300 whitespace-nowrap ${
                  isScrolled 
                    ? 'border-teal-600 text-teal-600 hover:bg-teal-50' 
                    : 'border-white text-white hover:bg-white/10'
                }`}
              >
                <i className="ri-map-pin-line text-lg"></i>
                <span className="font-medium">Nos Villes</span>
                <i className={`ri-arrow-down-s-line text-lg transition-transform duration-300 ${isCitiesOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {/* Dropdown Menu */}
              {isCitiesOpen && (
                <div 
                  className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-xl border border-gray-100 max-h-96 overflow-y-auto z-50"
                  onMouseEnter={() => {
                    clearTimeout(citiesTimeoutRef.current);
                    setIsCitiesOpen(true);
                  }}
                  onMouseLeave={handleCitiesMouseLeave}
                >
                  <div className="py-2">
                    {villes.map((ville) => (
                      <a
                        key={ville.href}
                        href={ville.href}
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-teal-50 hover:text-teal-600 transition-colors"
                      >
                        {ville.name}
                      </a>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Bouton Devis Gratuit */}
            <a
              href="/#contact"
              className="bg-teal-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-colors shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              Devis Gratuit
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 cursor-pointer touch-manipulation ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}
            aria-label="Menu"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <>
          {/* Overlay */}
          <div 
            className="fixed inset-0 bg-black/50 md:hidden z-40"
            onClick={() => setIsMobileMenuOpen(false)}
          ></div>
          
          {/* Menu Panel */}
          <div className="fixed top-16 sm:top-20 left-0 right-0 bottom-0 md:hidden bg-white shadow-2xl z-50 overflow-y-auto animate-slide-down">
            <div className="px-4 sm:px-6 py-6 space-y-1">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="block text-gray-900 hover:text-teal-600 hover:bg-teal-50 font-semibold cursor-pointer py-4 px-4 rounded-lg transition-all text-base touch-manipulation active:scale-95"
                >
                  {link.name}
                </a>
              ))}

              {/* Menu Villes Mobile */}
              <div>
                <button
                  onClick={() => setIsVillesMenuOpen(!isVillesMenuOpen)}
                  className="w-full text-left text-gray-900 hover:text-teal-600 hover:bg-teal-50 font-semibold cursor-pointer py-4 px-4 flex items-center justify-between rounded-lg transition-all touch-manipulation active:scale-95"
                >
                  <span className="text-base flex items-center gap-2">
                    <i className="ri-map-pin-line"></i>
                    Nos Villes
                  </span>
                  <i className={`ri-arrow-${isVillesMenuOpen ? 'up' : 'down'}-s-line text-xl`}></i>
                </button>
                {isVillesMenuOpen && (
                  <div className="pl-4 space-y-1 mt-2 max-h-64 overflow-y-auto bg-gray-50 rounded-lg p-2">
                    {villes.map((ville) => (
                      <a
                        key={ville.href}
                        href={ville.href}
                        onClick={() => setIsMobileMenuOpen(false)}
                        className="block text-sm text-gray-700 hover:text-teal-600 hover:bg-white py-3 px-4 rounded-lg transition-all touch-manipulation active:scale-95"
                      >
                        <i className="ri-map-pin-2-fill text-teal-500 mr-2"></i>
                        {ville.name}
                      </a>
                    ))}
                  </div>
                )}
              </div>
              
              {/* Mobile CTA Button */}
              <a
                href="/#contact"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block bg-teal-600 text-white px-6 py-4 rounded-xl font-bold hover:bg-teal-700 transition-colors text-center cursor-pointer mt-4 text-base shadow-lg touch-manipulation active:scale-95"
              >
                <i className="ri-phone-line mr-2 text-lg"></i>
                Devis Gratuit
              </a>
              
              {/* Quick Call Button */}
              <a
                href="tel:0980803684"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block bg-amber-400 text-gray-900 px-6 py-4 rounded-xl font-bold hover:bg-amber-500 transition-colors text-center cursor-pointer text-base shadow-lg touch-manipulation active:scale-95"
              >
                <i className="ri-phone-fill mr-2 text-lg"></i>
                09 80 80 36 84
              </a>
            </div>
          </div>
        </>
      )}
    </nav>
  );
}
